import { Component, inject, Signal } from '@angular/core';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { updateApplication } from '../../../../../../store/actions/application.actions';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { stages } from '../../general-letter.routes';
import { GeneralLetterInformationForm } from './forms/general-letter-information.form';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';

@Component({
  selector: 'app-general-letter-information-section',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SpinnerComponent,
    StagesComponent,
    ValidationErrorsComponent
  ],
  providers: [GeneralLetterInformationForm],
  templateUrl: './general-letter-information-section.component.html'
})
export class GeneralLetterInformationSectionComponent {

  public stages: string[] = stages;

  private store$: Store = inject(Store);

  private route: ActivatedRoute = inject(ActivatedRoute);

  private router: Router = inject(Router);

  public form: GeneralLetterInformationForm = inject(GeneralLetterInformationForm);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.store$.dispatch(updateApplication({
        id: this.application()?.uuid || '',
        application: this.form.value,
        successFnc: (applicationId: string) => {
          this.router.navigate(
            ['../zgody'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], { relativeTo: this.route });
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
